export type QUESTION_TYPE = 'open' | 'close_single' | 'close_multichoice' | 'matrix' | 'slider';

export const QUESTION_TYPE: {
  OPEN: QUESTION_TYPE,
  CLOSE_SINGLE: QUESTION_TYPE,
  CLOSE_MULTICHOICE: QUESTION_TYPE,
  MATRIX: QUESTION_TYPE,
  SLIDER: QUESTION_TYPE
} = {
  OPEN: 'open',
  CLOSE_SINGLE: 'close_single',
  CLOSE_MULTICHOICE: 'close_multichoice',
  MATRIX: 'matrix',
  SLIDER: 'slider'
};



// WEBPACK FOOTER //
// /dist/src/app/question/question-type.const.ts